import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
@Component({
  standalone: false,
  selector: 'app-generic-response',
  templateUrl: './generic.component.html',
  styleUrls: ['./generic.component.scss']
})
export class GenericComponent implements OnInit {
  responseCodeHeader: string;
  responseMessage: string;
  constructor(private route: ActivatedRoute) {}

  ngOnInit() {
    this.route.params.subscribe(params => {
      if (params['code'] != null) {
        switch (params['code']) {
        case '404': {
          this.responseCodeHeader = $localize`404 - Not found`;
          this.responseMessage = $localize`The requested URL or resource could not be found on the server.`;
          break;
        }
        case 'ipbanned': {
          this.responseCodeHeader = $localize`ACCESS DENIED`;
          this.responseMessage = $localize`Your IP has been blocked.`;
          break;
        }
        case '403': {
          this.responseCodeHeader = $localize`403 - Forbidden`;
          this.responseMessage = $localize`You do not have permission to access this URL or resource.`;
          break;
        }
        default : {
          this.responseCodeHeader = $localize`Something went wrong`;
          this.responseMessage =
          $localize`Our servers were not able to process your request. We apologise for the inconvenience.`;
        }
        }
      } else {
        this.responseCodeHeader = $localize`Something went wrong`;
        this.responseMessage =
        $localize`Our servers were not able to process your request. We apologise for the inconvenience.`;
      }
    });

  }
/*
  private printURL() {
     // Need to investigate how to get previous url
    this.responseMessage += '\n\r Your requested URL: ' + this.route.snapshot.url;
  }
*/
}
